// @apiglobal scope
import * as typedrequestInterfaces from '@api.global/typedrequest-interfaces';

export {
  typedrequestInterfaces
}